var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.areasFormatter)?_c('v-btn',{staticClass:"button-position d-flex align-center px-2 mediumGreen",attrs:{"elevation":"2"}},[_c('span',{staticClass:"mx-3 white--text text-h5"},[_vm._v(_vm._s(`${_vm.areasFormatter}`))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }